export default "__VITE_ASSET__DBU6RBf5__"